import { useEffect, useRef, useState } from "react";
import DocumentUpload from "../../DocumentUpload";
import { getBulkDropdownData } from "../../../api/keyvalue";
import { getDocumentByOpeAndRef } from "../../../api/documentUpload";
import "react-toastify/dist/ReactToastify.css";
import { MODULES } from "../../../const";

const TransporterInvoiceDocument = ({ tdhId }) => {
  const docRef = useRef();

  const [files, setFiles] = useState([]);
  const [documentTypeOptions, setDocumentTypeOptions] = useState([]);
  const [fileNameOptions, setFileNameOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [activeOptions, setActiveOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [documents, setDocuments] = useState([]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);

      const {
        doc_type: docTypeData,
        "file_name#16": fileNameData,
        active: activeData,
        status: statusData,
      } = await getBulkDropdownData([
        { key: "doc_type" },
        { key: "file_name", group: "16" },
        { key: "active" },
        { key: "status" },
      ]);

      setDocumentTypeOptions(docTypeData);
      setFileNameOptions(fileNameData);
      setActiveOptions(activeData);
      setStatusOptions(statusData);

      const docData = await getDocumentByOpeAndRef(16, tdhId);
      setDocuments(docData);
      setIsLoading(false);
    })();
  }, [tdhId]);

  return (
    <DocumentUpload
      opeType={16}
      ref={docRef}
      files={files}
      module={MODULES.Transaction}
      setFiles={setFiles}
      reference={tdhId}
      dropdown={{
        documentTypeOptions,
        statusOptions,
        fileNameOptions,
        activeOptions,
      }}
      isLoading={isLoading}
      editMode={true}
      currentValues={documents}
      isOnTheModal={true}
      showGridOnly={true}
    />
  );
};

export default TransporterInvoiceDocument;
